import {AssessmentNote} from "./assessmentNote";

export class PoamItem {

  currentYearSequence: string;
  complianceAreaControlId: string;
  name: string;
  topic: string;
  loe: string;
  requirementOrGuidance: string;
  affectedSystems: string;
  weaknessDescription: string;
  riskLevel: string;
  identificationDate: string;
  scheduledCompletionDate: string;
  actualCompletionDate: string;
  remediationPlansActionsMilestones: string;
  changesToRemediationPlansActionsMilestones: string;
  comments: string;
  projectControlItemId: number;
  responsibleParty: string;
  revisedTargetDate: string;
  howIdentified: string;
  actionPlanId: number;
  assessmentNotes: AssessmentNote[];
  currentStatus: string;
  impactedControls?: string;
  actionPlanTemplateId?: number;

  constructor(
    currentYearSequence,
    complianceAreaControlId,
    name,
    topic,
    loe,
    requirementOrGuidance,
    affectedSystems,
    weaknessDescription,
    riskLevel,
    identificationDate: Date,
    scheduledCompletionDate: Date,
    actualCompletionDate: Date,
    remediationPlansActionsMilestones,
    changesToRemediationPlansActionsMilestones,
    comments,
    projectControlItemId,
    responsibleParty,
    revisedTargetDate,
    howIdentified,
    currentStatus,
    assessmentNotes,
    actionPlanId,
    impactedControls,
    actionPlanTemplateId){

    this.currentYearSequence = currentYearSequence;
    this.complianceAreaControlId = complianceAreaControlId;
    this.name = name;
    this.topic = topic;
    this.loe = loe;
    this.requirementOrGuidance = requirementOrGuidance;
    this.affectedSystems = affectedSystems;
    this.weaknessDescription = weaknessDescription;
    this.riskLevel = riskLevel;
    this.identificationDate = identificationDate != null ? new Date(identificationDate).toLocaleDateString(): '';
    this.scheduledCompletionDate = scheduledCompletionDate != null ? new Date(scheduledCompletionDate).toLocaleDateString(): '';
    this.actualCompletionDate = actualCompletionDate != null ? new Date(actualCompletionDate).toLocaleDateString(): '';
    this.remediationPlansActionsMilestones = remediationPlansActionsMilestones != null ? remediationPlansActionsMilestones: '';
    this.changesToRemediationPlansActionsMilestones = changesToRemediationPlansActionsMilestones != null ? changesToRemediationPlansActionsMilestones: '';
    this.comments = comments != null ? comments: '';
    this.projectControlItemId = projectControlItemId;
    this.responsibleParty = responsibleParty || '';
    this.revisedTargetDate = revisedTargetDate != null ? new Date(revisedTargetDate).toLocaleDateString(): '';
    this.howIdentified = howIdentified || '';
    this.currentStatus = currentStatus || '';
    this.assessmentNotes = assessmentNotes;
    this.actionPlanId = actionPlanId;
    this.impactedControls = impactedControls;
    this.actionPlanTemplateId = actionPlanTemplateId;
  }
}
